// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';
import { format } from 'date-fns';
import classNames from 'classnames';

// Components
import MobileDatePicker from 'components/atoms/MobileDatePicker';
import DesktopDatePicker from 'components/atoms/DesktopDatePicker';

// Utils
import { isValidRegistrationDate } from 'utils/date';

import './RegistrationDateBuilder.scss';

const ns = 'registration-date-builder';

type Props = {
  intl: IntlShape,
  vehicleYear: number,
  regDate: string,
  selectRegDate: (date: Date) => void,
  vehicleEditableEnabled: boolean,
  localeCode: string,
  languageCode: string
};

type State = {
  date: Date
};

class RegistrationDateBuilder extends React.Component<Props, State> {
  // eslint-disable-next-line react/sort-comp
  existingDate =
    this.props.regDate &&
    new Date(
      +this.props.regDate.substr(0, 4),
      +this.props.regDate.substr(5, 2) - 1,
      +this.props.regDate.substr(8, 2)
    );
  vehicleDate = this.props.vehicleYear
    ? this.props.vehicleYear
    : new Date().getFullYear();

  state = {
    date: isValidRegistrationDate(this.existingDate)
      ? new Date(this.existingDate)
      : new Date(this.vehicleDate, 0, 1)
  };

  onChange = (date: Date) => {
    const { selectRegDate } = this.props;
    this.setState({
      date
    });
    selectRegDate(format(date, 'YYYY-MM-DD'));
  };

  render() {
    const {
      intl,
      vehicleYear,
      vehicleEditableEnabled,
      localeCode,
      languageCode
    } = this.props;
    const minDate = new Date(vehicleYear - 1, 0, 1);
    const maxDate = new Date();
    const desktopDatePickerClassName = classNames({
      [`${ns}__desktop-date-picker--disabled`]: !vehicleEditableEnabled,
      [`d-none d-sm-block`]: true
    });
    return (
      <div>
        <div className={`d-sm-none ${ns}__title`}>
          {intl.formatMessage({
            id: 'c8.registration.date.title.in.service.date'
          })}
        </div>
        <div className={`${ns}__subtitle py-0 mb-3`}>
          {intl.formatMessage({
            id: 'c8.registration.date.not.sure.just.leave.this.date'
          })}
        </div>
        <div className={`d-block d-sm-none`}>
          <MobileDatePicker
            onChange={this.onChange}
            value={this.state.date}
            minDate={minDate}
          />
        </div>
        <div className={desktopDatePickerClassName}>
          <DesktopDatePicker
            className={`d-flex justify-content-center`}
            onChange={this.onChange}
            value={this.state.date}
            minDate={minDate}
            maxDate={maxDate}
            disabled={!vehicleEditableEnabled}
            minDetail={'decade'}
            locale={localeCode}
            languageCode={languageCode}
            intl={intl}
          />
        </div>
      </div>
    );
  }
}

export default RegistrationDateBuilder;



// WEBPACK FOOTER //
// ./src/components/molecules/RegistrationDateBuilder/RegistrationDateBuilder.js